import { Components } from '@ionic/core';
import { IonChip, IonSpinner } from '@ionic/react';
import {
  DOMAttributes,
  HTMLAttributes,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { useMeasure } from 'react-use';

type ChipProps = Partial<Components.IonChip> &
  Partial<HTMLAttributes<HTMLIonChipElement>> &
  Partial<DOMAttributes<HTMLIonChipElement>>;

export interface BaseChipProps {
  chipButtonId?: string;
  className?: string;
  children?: ReactNode;
  chipProps?: ChipProps;
}

export interface LoadingChipProps extends BaseChipProps {
  loading: boolean;
  setWidthOnInitializationOnly?: boolean;
  spinnerProps?: Partial<Components.IonSpinner> &
    Partial<DOMAttributes<HTMLIonSpinnerElement>> &
    Partial<HTMLAttributes<HTMLIonSpinnerElement>>;
}

const LoadingChipButton = (props: LoadingChipProps): ReactElement => {
  const {
    children,
    className,
    loading,
    chipProps,
    spinnerProps,
    setWidthOnInitializationOnly = false,
  } = props;
  const [minWidth, setMinWidth] = useState<number>(0);

  const [ref, { width: chipButtonWidth }] = useMeasure<HTMLIonChipElement>();

  useEffect(() => {
    const max = Number(Math.max(minWidth, chipButtonWidth).toFixed(0));
    if (
      (max !== minWidth && !setWidthOnInitializationOnly) ||
      (minWidth === 0 && setWidthOnInitializationOnly)
    ) {
      setMinWidth(max);
    }
  }, [minWidth, chipButtonWidth, setWidthOnInitializationOnly]);

  return (
    <IonChip
      id={props.chipButtonId}
      ref={ref}
      {...chipProps}
      style={{
        minWidth,
      }}
      className={className}
    >
      {loading && <IonSpinner name="dots" {...spinnerProps} />}
      {!loading && children}
    </IonChip>
  );
};

export { LoadingChipButton };
